export const sliderItems = [
    {
        id: 1,
        img : "https://img.freepik.com/free-photo/smiling-attractive-woman-stylish-colorful-outfit-jumping-with-shopping-bags-pink-yellow-background-polo-neck-striped-mini-skirt-shopaholic-sale-fashion-summer-trend_285396-2421.jpg?w=2000",
        title: "SUMMER SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "f5fafd",
    },
    {
        id: 2,
        // img: "https://i.ibb.co/DG69bQ4/2.png",
        img: "https://img.freepik.com/premium-photo/stylish-woman-with-shopping-bags-walks-through-city-streets-consumerism-shopping-lifestyle-concept_217236-18721.jpg?w=2000",
        title: "AUTUMN COLLECTION",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fcf1ed",
    },
    {
        id: 3,
        img: "https://media.istockphoto.com/id/1073935306/photo/girls-carrying-shopping-bags.jpg?s=612x612&w=0&k=20&c=JB-TrME32dc0VTnaXVxsbJIExZqR71m-iyVOnG-7puM=",
        title: "LOUNGEWEAR LOVE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg: "fbf0f4",
    },
];

export const categories = [
    {
        id: 1,
        img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        title: "SHIRT STYLE!",
        cat : "women"
    },
    {
        id: 2,
        img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        title: "LOUNGEWEAR LOVE",
        cat : "jacket"
    },
    {
        id: 3,
        img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
        title: "LIGHT JACKETS",
        cat : "man"
    },
];

export const popularProducts = [
    {
        id: 1,
        img: "https://cdn.pixabay.com/photo/2016/12/06/09/31/blank-1886008__340.png",
    },
    {
        id: 2,
        img: "https://m.media-amazon.com/images/I/61hcyEeQ1SL._UX569_.jpg",
    },
    {
        id: 3,
        img: "https://i.pinimg.com/736x/7c/53/f2/7c53f2d86f3a0bdc24a56c46a13725e6--kurta-salwar-southall.jpg",
    },
    {
        id: 4,
        img: "https://thumbs.dreamstime.com/b/stylish-men-s-jacket-white-background-220858808.jpg",
    },
    {
        id: 5,
        img: "https://rukminim1.flixcart.com/image/832/832/l16rde80/shirt/4/y/y/xxl-st2-vebnor-original-imagcsujaggmjyux.jpeg?q=70",
    },
    {
        id: 6,
        img: "https://4.imimg.com/data4/LL/TW/MY-33084776/men-s-shirt-500x500.jpg",
    },
    {
        id: 7,
        img: "https://i.pinimg.com/236x/3e/94/bc/3e94bc989541c3af77fc694727cf2f43--teal-dresses-and-dresses.jpg",
    },
    {
        id: 8,
        img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
]
